<ll-titulo>Agregar Contenido</ll-titulo>
<ll-toolnavbar></ll-toolnavbar>

<plan-personal-contenido-new [sessionId]="sessionId" [planificacionId]="planificacionId"></plan-personal-contenido-new>
